import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Box, Card, CardMedia, Skeleton, Stack } from '@mui/material';
import Slider from 'react-slick'; // Import the Slider component from react-slick
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useSelector } from 'react-redux';
import { useDevice } from '../hooks/useResponsive';
import useCloudinary from '../hooks/useCloudinaryImage';

CarDeliverySection.propTypes = {
  carDeliveryList: propTypes.any,
  productSingle: propTypes.string,
};
export default function CarDeliverySection({ carDeliveryList, productSingle }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { loading } = useSelector((state) => ({
    loading: state.CarDelivery.loading,
  }));
  const { isMobile } = useDevice();

  // console.log(carDeliveryList);
  // const CarDelivery = [
  //   {
  //     image: '/assets/images/ReviewCarousal/review1.png',
  //   },
  //   {
  //     image: '/assets/images/ReviewCarousal/review1.png',
  //   },
  //   {,

  //     image: '/assets/images/ReviewCarousal/review1.png',
  //   },
  // ];

  // Configuration for the carousel
  const settings = {
    dots: true,
    afterChange: (index) => setCurrentSlide(index),
    slidesToShow: 3.2,
    slidesToScroll: 1,
    infinite: false,
    speed: 500,
    arrows: false,
    customPaging: (i) => {
      const isActive = i === Math.round(currentSlide);
      return (
        <button type="button">
          <span
            style={{
              display: 'block',
              width: '5px',
              height: '5px',
              borderRadius: '50%',
              backgroundColor: isActive ? '#ffffff' : '#888888',
              transition: 'all 0.3s ease',
              margin: '0 auto',
            }}
          />
        </button>
      );
    },
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.4,
          slidesToScroll: 1,
          // centerMode: false,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Stack
      sx={{
        maxWidth: '100%',
        px: isMobile ? 0 : '75px',
        mt: isMobile ? 4 : 21,
        mb: !isMobile && 10,
        ...(productSingle && {
          mt: isMobile ? 1 : 0,
          mb: !isMobile && 2,
        }),
      }}
    >
      <Stack className="car-delivery-section">
        <CardMedia
          component="img"
          src={isMobile ? '/assets/images/HomeMobile/16.webp' : '/assets/images/HomeMobile/16Web.webp'}
          alt="16 year"
          sx={{ mb: !isMobile && 2 }}
        />
        {carDeliveryList?.length > 0 && (
          <Box
            sx={{
              maxWidth: '100%',
              px: 0,
              pl: 1,
              pb: 8,
              '& .slick-dots': {
                display: 'flex !important',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '6px',
                bottom: '-30px',
              },
              '& .slick-dots li': {
                margin: '0 !important',
              },
              '& .slick-dots li button': {
                padding: 0,
                width: 'auto',
                height: 'auto',
              },
              '& .slick-dots li button:before': {
                display: 'none', // ✅ Hides Slick's default dot
                content: 'none',
              },
            }}
          >
            <Slider {...settings}>
              {loading
                ? [...Array(4)].map((_, index) => (
                    <Stack key={index} sx={{ pl: 1, borderRadius: '8px' }}>
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        height={112}
                        width="100%"
                        sx={{ backgroundColor: '121212' }}
                      />
                    </Stack>
                  ))
                : carDeliveryList?.map((item, index) => (
                    <Stack key={index} sx={{ pl: 1, borderRadius: '8px' }}>
                      <Card className="CardTransform-feature-cars">
                        {item && item?.images[0] ? (
                          <CardMedia
                            component="img"
                            src={
                              item?.images?.[0]?.url
                                ? // eslint-disable-next-line react-hooks/rules-of-hooks
                                  useCloudinary(item.images[0].url, 'w_400,q_auto,f_auto')
                                : '/assets/images/Feature/black.png'
                            }
                            alt="Card Image"
                            sx={{ height: isMobile ? '112px' : '279px' }}
                          />
                        ) : (
                          <CardMedia component="img" src={'/assets/images/Feature/black.png'} alt="Card Image" />
                        )}
                      </Card>
                    </Stack>
                  ))}
            </Slider>
          </Box>
        )}
      </Stack>
    </Stack>
  );
}
